exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".latest-per-unit-measurements .data-label{color:#aaa}.latest-per-unit-measurements .use-amount{padding-top:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/latest-per-unit-measurements/index.scss
// module id = 5268
// module chunks = 0